// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconButton-module__root--sqEpJ {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid var(--button-border-color);
  appearance: none;
  background: var(--button-background);
  color: var(--button-color);
  font: inherit;
  line-height: 1;
  cursor: pointer;
}

.IconButton-module__shape-default--PhCU5 {
  border-radius: 6px;
}

.IconButton-module__shape-normal--vCXNu {
  border-radius: 50%;
}

.IconButton-module__shape-link--I61uM {
  border-color: transparent;
  border-radius: 0;
  background: transparent;
}

.IconButton-module__variant-default--cZu5R {
  --button-background: #fff;
  --button-border-color: #e5e5e5;
  --button-color: #1a1a1a;
}

.IconButton-module__variant-primary--bZLY5 {
  --button-background: #000;
  --button-border-color: #000;
  --button-color: #fff;
}

.IconButton-module__variant-secondary--qGWGl {
  --button-background: #fff;
  --button-border-color: #000;
  --button-color: #000;
}

.IconButton-module__variant-accent--SlFYB {
  --button-background: #ff9800;
  --button-border-color: #ff9800;
  --button-color: #000;
}

.IconButton-module__variant-ghost--q5DNG {
  --button-background: #fff;
  --button-border-color: #aaa;
  --button-color: #555;
}

.IconButton-module__variant-soft--Rb73l {
  --button-background: #fff4df;
  --button-border-color: #d9c6a5;
  --button-color: #333;
}

.IconButton-module__variant-danger--SGuNO {
  --button-background: #c92a24;
  --button-border-color: #c92a24;
  --button-color: #fff;
}

.IconButton-module__variant-danger-weak--ksPz1 {
  --button-background: #fff;
  --button-border-color: #b3261e;
  --button-color: #b3261e;
}

.IconButton-module__size-small--jeeUA {
  width: 32px;
  height: 32px;
}

.IconButton-module__size-medium--u6Gfc {
  width: 40px;
  height: 40px;
}

.IconButton-module__size-large--SEmKG {
  width: 48px;
  height: 48px;
}

.IconButton-module__root--sqEpJ:disabled,
.IconButton-module__root--sqEpJ[aria-disabled='true'] {
  cursor: not-allowed;
  opacity: 0.45;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/IconButton/IconButton.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,4CAA4C;EAC5C,gBAAgB;EAChB,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf","sourcesContent":[".root {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 1px solid var(--button-border-color);\n  appearance: none;\n  background: var(--button-background);\n  color: var(--button-color);\n  font: inherit;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.shape-default {\n  border-radius: 6px;\n}\n\n.shape-normal {\n  border-radius: 50%;\n}\n\n.shape-link {\n  border-color: transparent;\n  border-radius: 0;\n  background: transparent;\n}\n\n.variant-default {\n  --button-background: #fff;\n  --button-border-color: #e5e5e5;\n  --button-color: #1a1a1a;\n}\n\n.variant-primary {\n  --button-background: #000;\n  --button-border-color: #000;\n  --button-color: #fff;\n}\n\n.variant-secondary {\n  --button-background: #fff;\n  --button-border-color: #000;\n  --button-color: #000;\n}\n\n.variant-accent {\n  --button-background: #ff9800;\n  --button-border-color: #ff9800;\n  --button-color: #000;\n}\n\n.variant-ghost {\n  --button-background: #fff;\n  --button-border-color: #aaa;\n  --button-color: #555;\n}\n\n.variant-soft {\n  --button-background: #fff4df;\n  --button-border-color: #d9c6a5;\n  --button-color: #333;\n}\n\n.variant-danger {\n  --button-background: #c92a24;\n  --button-border-color: #c92a24;\n  --button-color: #fff;\n}\n\n.variant-danger-weak {\n  --button-background: #fff;\n  --button-border-color: #b3261e;\n  --button-color: #b3261e;\n}\n\n.size-small {\n  width: 32px;\n  height: 32px;\n}\n\n.size-medium {\n  width: 40px;\n  height: 40px;\n}\n\n.size-large {\n  width: 48px;\n  height: 48px;\n}\n\n.root:disabled,\n.root[aria-disabled='true'] {\n  cursor: not-allowed;\n  opacity: 0.45;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `IconButton-module__root--sqEpJ`,
	"shape-default": `IconButton-module__shape-default--PhCU5`,
	"shape-normal": `IconButton-module__shape-normal--vCXNu`,
	"shape-link": `IconButton-module__shape-link--I61uM`,
	"variant-default": `IconButton-module__variant-default--cZu5R`,
	"variant-primary": `IconButton-module__variant-primary--bZLY5`,
	"variant-secondary": `IconButton-module__variant-secondary--qGWGl`,
	"variant-accent": `IconButton-module__variant-accent--SlFYB`,
	"variant-ghost": `IconButton-module__variant-ghost--q5DNG`,
	"variant-soft": `IconButton-module__variant-soft--Rb73l`,
	"variant-danger": `IconButton-module__variant-danger--SGuNO`,
	"variant-danger-weak": `IconButton-module__variant-danger-weak--ksPz1`,
	"size-small": `IconButton-module__size-small--jeeUA`,
	"size-medium": `IconButton-module__size-medium--u6Gfc`,
	"size-large": `IconButton-module__size-large--SEmKG`
};
export default ___CSS_LOADER_EXPORT___;
